let currencies = [
    {"id":1,"orderindex":1,"name":"Euro", "simbol":'€'},
    {"id":2,"orderindex":2,"name":"Pound", "simbol":'£'},
    {"id":3,"orderindex":3,"name":"Dollar", 'simbol':'$'}
];